module.exports = __webpack_public_path__ + "static/media/profile_img_2.637c2a84.jpg";